import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { UseTimeZone } from '../../../common/hooks/useTimeZone'
import { Element } from '../../../common/html/element'
import { Table } from '../../../common/table'
import { FORMAT, formatDateTime } from '../../../helpers/datetime'
import { TableFooter } from './TableFooter'
import { AVAILABLE_PACKAGE_KEYS, AVAILABLE_PACKAGE_TITLE } from './constants'
import './i18n'
import {
  selectAvailablePackageDataById,
  selectAvailablePackageIds,
  selectFilter,
  selectFilterByKey,
  selectLoadingAvailablePackage,
} from './store/slice'
import { getUserPricingPackagesPaged } from './store/thunk'

export const TableComponent = () => {
  const dispatch = useDispatch()

  const ids = useSelector(selectAvailablePackageIds)
  const isLoading = useSelector(selectLoadingAvailablePackage)
  const locale = useSelector((state) => state.i18n.locale)

  const purchaseDate = useSelector(selectFilterByKey('purchaseDate'))
  const expiryDate = useSelector(selectFilterByKey('expiryDate'))
  const packageType = useSelector(selectFilterByKey('packageType'))
  const page = useSelector(selectFilterByKey('page'))
  const pageSize = useSelector(selectFilterByKey('pageSize'))
  const allFilter = useSelector(selectFilter)

  const timeZone = UseTimeZone()

  useEffect(() => {
    dispatch(
      getUserPricingPackagesPaged({
        FiinGateReportTypeId: packageType?.value,
        Page: page,
        PageSize: pageSize,
        StartDateFrom: purchaseDate?.from,
        StartDateTo: purchaseDate?.to,
        EndDateFrom: expiryDate?.from,
        EndDateTo: expiryDate?.to,
      }),
    )
  }, [allFilter, locale])

  return (
    <>
      <Table
        ids={ids}
        isNoDataWithHead
        getDataFromRedux={selectAvailablePackageDataById}
        schema={getSchema(locale, timeZone)}
        isLoading={isLoading}
        autoHeightMax={500}
        renderPagination={() => <TableFooter />}
      />
    </>
  )
}

const getSchema = (locale, timeZone) => {
  return AVAILABLE_PACKAGE_TITLE.map((item) => {
    const result = {
      title: <Translate value={item.title} />,
      colId: item.key,
    }

    if (item.key === AVAILABLE_PACKAGE_KEYS.PACKAGE_TYPES) {
      return {
        ...result,
        render: (val) => {
          return <Element className="fw600">{val}</Element>
        },
      }
    }

    if (
      item.key === AVAILABLE_PACKAGE_KEYS.EXPIRY_DATE ||
      item.key === AVAILABLE_PACKAGE_KEYS.PURCHASE_DATE
    ) {
      return {
        ...result,
        render: (val) => {
          return formatDateTime(val, FORMAT.DATE, locale, timeZone)
        },
      }
    }

    return {
      ...result,
      render: (val) => {
        return val
      },
    }
  })
}
